export enum FeatureLifecycleStatus {
  NotReleased = 'NotReleased',
  InRollout = 'InRollout',
  FullyReleased = 'FullyReleased',
}
